import React from "react";

const DetailsInformation = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>
          Details in respect of information available to or held by it in an
          electronic form
        </h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <p>
          All the general information regarding activities taken up by the
          Corporation is avalable in the Corporation&#39;s website as well as in
          the form of hard copy in the office(s) of the Corporation.The
          weighment of seed and other items is\ being done on the electronic
          weigh bridges.
        </p>

        <p>
          <b>
            Following record of Company Section is held by the Corporation in
            Electronic form:-
          </b>
        </p>

        <ol>
          <li>Shareholders Registers</li>
          <li>Share Transfer Register</li>
          <li>Share Transmission Register</li>
          <li>Duplicate Share Register</li>
          <li>Directors Register</li>
          <li>Attendance registers of various meetings</li>
          <li>Minutes book of various meetings as per Companies Act.2013</li>
          <li>Register of RTI Appeals.</li>
        </ol>
      </div>
    </div>
  );
};

export default DetailsInformation;
